import React, { useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import {
  repositoryMdm,
  repositoryPayment,
  repositoryPos,
} from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import PrintedInvoice from "../Invoice/PrintedInvoice";
import { MessageResponse } from "../../model/MessageResponse";

const PrintInvoice = ({
  idPrint,
  setIdPrint,
  isPrinting,
  setIsPrinting,
  price,
  orderNumber,
  buyerName,
  isDVT,
}: any) => {
  // console.log("price", price);
  // Invoice
  const componentRef = React.useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
    @page{
      size: 80mm 297mm;
      margin:0;
    }
    body:{
      margin: 0;
      color: #000;
    }`,
  });
  const [valueQRCode, setValueQRCode] = useState<string | null>(null);
  const [invoiceData, setInvoiceData] = useState<any>(null);

  const fetchInvoiceData = async () => {
    // await handleCreateQrCode();
    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblOrderHeader/print-order?ids=${idPrint}`
      );
      if (response && response.success) {
        let result = response.data;
        console.log("result", result[0].codAmount);
        await handleCreateQrCode(result[0].codAmount);
        setInvoiceData(result[0]);
      } else {
        setInvoiceData(null);
        // setIsPrinting(false);
        NotificationExtension.Fails("In hóa đơn không thành công");
      }
    } catch (error) {
      setInvoiceData(null);
      // setIsPrinting(false);
      NotificationExtension.Fails("In hóa đơn không thành công");
    }
  };

  const handleCreateQrCode = async (priceData: number) => {
    console.log("[DVT-DEBUG] PrintInvoice handleCreateQrCode - isDVT:", isDVT);
    if (isDVT) return;
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/Public/ip`
      );
      const ipAddress = response?.data || "";
      const callapi = await repositoryPayment.post<MessageResponse<any>>(
        `/api/TblMBQRcode/gen-qr-mb-v2`,
        {
          amount: priceData,
          ipAddress: ipAddress, // Gán ipAddress vừa lấy được
          orderInfo: orderNumber, // Gán orderInfo đã xác định
          orderNumber: orderNumber,
        }
      );

      if (callapi?.success && callapi?.data && callapi?.data?.qr_url) {
        setValueQRCode(callapi?.data?.qr_url);
      } else {
        // setGenQrError(true);
        console.log("Lỗi tạo mã QR");
        setValueQRCode(null);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    if (idPrint && idPrint !== null) {
      fetchInvoiceData();
    }
  }, [idPrint]);
  useEffect(() => {
    if (isPrinting && invoiceData && invoiceData !== null) {
      handlePrint();
      setIsPrinting(false);
      setIdPrint(null);
    }
  }, [invoiceData]);
  // console.log("invoiceData", invoiceData);
  // console.log("isPrinting", isPrinting);
  // console.log("idPrint", idPrint);
  // console.log("đang ở file xử lý in hóa đơn");
  // console.log("valueQRCode", valueQRCode);
  return (
    <>
      <PrintedInvoice
        componentRef={componentRef}
        invoiceData={invoiceData}
        valueQRCode={valueQRCode}
        companyCode={isDVT ? "DVT" : "HACOM"}
        buyerName={buyerName}
      />
    </>
  );
};

export default PrintInvoice;
